import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';

// use for setting context properties

const useSettings = () => useContext(SettingsContext);

export default useSettings;
